import { useEffect, useState } from 'react';
import { getOrgLevelsWithCostCenter } from '../services/organizationService.js';
import { ToastComponent } from '@tylertech/forge';
import { messageManager } from '../components/System/messageManager/messageManager.js';
import { useUser } from '../contexts/userContext.js';
import { useNameConventions } from '../contexts/nameConventionsContext.js';

const useDepartmentsAndDivisions = () => {
  const [filteredDepartmentsFromAccUpload, setFilteredDepartmentsFromAccUpload] = useState([]);
  const [filteredDivisionsFromAccUpload, setFilteredDivisionsFromAccUpload] = useState([]);
  const [departmentName, setDepartmentName] = useState(null);
  const [divisionName, setDivisionName] = useState(null);
  const [throwNoAccessToast, setThrowNoAccessToast] = useState(null);
  const { user, costModel } = useUser();
  const { nameConventions } = useNameConventions();

  const prepare = async () => {
    let _departmentsFromAccUpload = [];
    let _divisionsFromAccUpload = [];

    if (costModel) {
      //taking the first levels because we can't be sure it will be called 'Department'
      if (costModel.organizationLevelTypes) {
        costModel.organizationLevelTypes[0].organizationLevels.map(orgLevel => {
          _departmentsFromAccUpload.push(orgLevel);
        });

        // WILL_BREAK_WITH_ONLY_ONE_ORG_LEVEL
        if (costModel.organizationLevelTypes[1]) {
          costModel.organizationLevelTypes[1].organizationLevels.map(orgLevel => {
            _divisionsFromAccUpload.push(orgLevel);
          });
        }
      } 
    } else {
      ToastComponent.present({
        message: messageManager(nameConventions).SOMETHING_WENT_WRONG,
      });
    }

    const getOrgLevelsWithCostCenterRes = await getOrgLevelsWithCostCenter();
    if (getOrgLevelsWithCostCenterRes.status === 200) {
      const departments = getOrgLevelsWithCostCenterRes.data;
      const groupedDepartmentsAndDivisionsByCostCenters = departments
        .reduce((a, c) => {
          if (!a[c.costCenterName]) {
            a[c.costCenterName] = [];
          }
          a[c.costCenterName].push(c);
          return a;
        }, {});
      filteredDepartmentsAndDivisionsByCostCenter(groupedDepartmentsAndDivisionsByCostCenters, _departmentsFromAccUpload, _divisionsFromAccUpload);
    } else {
      ToastComponent.present({
        message: messageManager(nameConventions).ORGANIZATION_HIERARCHY.FETCH_ORGANIZATION_LEVELS_WITH_COST_CENTER_ERROR,
      });
    }
  };

  useEffect(() => {
    prepare();
  }, [user?.activeOrganization]);

  const filteredDepartmentsAndDivisionsByCostCenter = (groupedDepartmentsAndDivisionsByCostCenters, departmentsFromAccUpload, divisionsFromAccUpload) =>{
    const allCostCenters = user.costCenters;
    const isAllCostCentersOption = (user?.activeCostCenters && user?.activeCostCenters?.length === allCostCenters.length) || user?.activeCostCenters?.length === 0;
    let filteredByCostCenters = [];

    for (const acc of user.activeCostCenters) {
      if (groupedDepartmentsAndDivisionsByCostCenters[acc]) { 
        filteredByCostCenters = [...filteredByCostCenters, ...groupedDepartmentsAndDivisionsByCostCenters[acc]];
      }
    }

    const filteredDepartments = filteredByCostCenters && filteredByCostCenters.length ?
      departmentsFromAccUpload.filter(x => filteredByCostCenters.some(cc => x.organizationLevelTypeId === cc.orgLevelTypeId && x.name === cc.orgLevelName && cc.orgLevelTypeId === 1))
      : isAllCostCentersOption ?
        departmentsFromAccUpload
        : [];
    setFilteredDepartmentsFromAccUpload(filteredDepartments.map(x => x.name).sort());
    setDepartmentName(null);

    const filteredDivisions = filteredByCostCenters && filteredByCostCenters.length ?
      divisionsFromAccUpload.filter(x => filteredByCostCenters.some(cc => x.organizationLevelTypeId === cc.orgLevelTypeId && x.name === cc.orgLevelName && cc.orgLevelTypeId === 2))
      : isAllCostCentersOption ?
        divisionsFromAccUpload
        : [];
    setFilteredDivisionsFromAccUpload(filteredDivisions.map(x => x.name).sort());
    setDivisionName(null);
  };

  return {
    filteredDepartmentsFromAccUpload,
    filteredDivisionsFromAccUpload,
    departmentName,
    setDepartmentName,
    divisionName,
    setDivisionName,
    throwNoAccessToast, 
    setThrowNoAccessToast
  };
};

export default useDepartmentsAndDivisions;
